// CustomTooltip.jsx
import React from "react";
import "./CustomTooltip.scss";

const CustomTooltip = (props) => {
  const { value } = props;
  if (value == null || value === "") return null;
  const normalized = String(value).replace(/\\n/g, "\n");
  const lines = normalized.split(/\r?\n/);
  return (
    <div className="tooltip-container">
      {lines.map((val, index) => (
        <div key={index}>{val}</div>
      ))}
    </div>
  );
};


export default CustomTooltip;
